import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="font-mono text-cyber tracking-widest animate-pulse">LOADING...</div>
      </div>
    );
  }

  if (!user) return <Navigate to={role === "admin" ? "/admin" : "/login"} replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;

  return children;
}
